import gql from 'graphql-tag';

export const ACTIVE_LICENSES_QUERY = gql`
  query GetActiveLicenses {
    operativeViewer {
      id
      isPOSAccessBlocked
      isInvoiceWarningActive

      stripePaymentStatus

      activeLicenses {
        id
        product
        deviceId
        provider
      }
    }
  }
`;
